import { slugify } from '../slugify'
import {
  camelCase as camelCasePrimitive,
  camelCaseTransformMerge,
} from 'camel-case'

export { slugify }

export const pascalCase = (input: string) => {
  return camelCasePrimitive(input, {
    transform: (part, index) => {
      return index === 0
        ? part.charAt(0).toUpperCase() + part.slice(1)
        : camelCaseTransformMerge(part, index)
    },
  })
}

export const camelCase = (input: string) =>
  camelCasePrimitive(input, { transform: camelCaseTransformMerge })

const fileNamePreserve = new Set(['.', '(', ')'])

export const slugifyFileName = (fileName: string) => {
  return slugify(fileName, {
    preserve: fileNamePreserve,
  })
}

const titleReplacements = new Map<string, string>().set('.', '-')

export const getSlugFromTitle = (title: string) => {
  return slugify(title, { customReplacements: titleReplacements })
}

type ReturnSlug<B extends boolean> = B extends true ? string : string | null

export function getRepoSlugWithoutCollisions<B extends boolean = false>(
  id: string,
  title: string,
  existingItems: { id: string; slug: string }[],
  throwOnEmptySlug?: B
): ReturnSlug<B> {
  const slug = getSlugFromTitle(title)

  if (slug === '') {
    if (throwOnEmptySlug) {
      throw new Error('Slug function yielded an empty string.')
    }
    // @ts-expect-error - this is a conditional return
    return null
  }

  const existingSlugs = existingItems
    .filter((i) => i.id !== id)
    .map((i) => i.slug)

  const candidate = slug
  const buildSuffix = (index: number) => (index === 0 ? '' : `-${index}`)

  let i = 0
  while (existingSlugs.includes(candidate + buildSuffix(i))) {
    i++

    if (i > 100) {
      throw new Error('Too many slug collisions')
    }
  }
  return candidate + buildSuffix(i)
}
